/**
 * Compara dos objetos (por valores, no por referencia), devuelve true si son iguales.
 * Se hace una comparation recursiva, se comparan todos los valores.
 * Ojo que puede ser muy costozo para objetos grandes.
 *
 * @param {object} - el objeto 1, realemente puede ser un array o un string o lo que sea
 * @param {object} - el objeto 2, idem
 *
 * @return {boolean} true si los objetos son exactamente iguales
 */

export function compare(a, b) {
  if (typeof a === 'object') {
    return compareObject(a, b);
  }

  /* compare primitive values */
  return a === b;
}

/**
 * Devuelve true si los objetos son iguales.
 *
 * @param {Object} a objeto uno
 * @param {any} b debería ser objeto
 * @returns {boolean}
 */
function compareObject(a, b) {
  if (a === b) {
    return true;
  }

  /* compare arrays */
  if (Array.isArray(a)) {
    return compareArray(a, b);
  }

  /* compare objects */
  if (typeof b !== 'object') {
    return false;
  }

  return compareObjectDeep(a, b);
}

/**
 * Devuelve true si los objetos son iguales.
 *
 * @param {Object} a objeto uno
 * @param {any} b debería ser objeto
 * @returns {boolean}
 */
function compareObjectDeep(a, b) {
  const keys = Object.keys(a);
  const len = keys.length;
  if (len !== Object.keys(b).length) {
    return false;
  }
  if (!len) {
    return a.toString() === b.toString();
  } // necesario porque puede ser por ejemplo new Date()
  return keys.reduce((acc, cur) => acc && compare(a[cur], b[cur]), true);
}

/**
 * Devuelve true si los array son iguales
 * @param {any[]} a valor uno de tipo array
 * @param {any} b valor dos, que debería ser de tipo array
 * @returns {boolean}
 */
function compareArray(a, b) {
  if (!Array.isArray(b)) {
    return false;
  }
  const len = a.length;
  if (len !== b.length) {
    return false;
  }
  if (!len) {
    return true;
  }
  return a.reduce((acc, cur, i) => acc && compare(cur, b[i]), true);
}
